import React from 'react';
//import { Link } from 'react-router-dom';
//import banner from '../assets/images/slider/banner.jpeg';
import lib3 from '../assets/images/slider/slider1.jpg';

export default function AboutUs() {
  const aboutUsStyles = `
    .about_section-bg {
      background: linear-gradient(120deg, #e0f7fa 0%, #b3e6fc 100%);
      min-height: 100vh;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .about_section-modern {
      background: #fff;
      border-radius: 22px;
      box-shadow: 0 4px 32px 0 rgba(6,53,71,0.10);
      padding: 2.5rem 2.2rem;
      margin: 2.5rem auto;
      max-width: 1100px;
    }
    .about_section-modern .img-box img {
      border-radius: 22px;
      box-shadow: 0 2px 16px 0 rgba(6,53,71,0.13);
      max-width: 100%;
      height: auto;
      background: #f8fafb;
    }
    .about_section-modern .detail-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      padding-left: 1.5rem;
    }
    .about_section-modern .heading_container h2 {
      font-size: 2.2rem;
      font-weight: 900;
      color: #063547;
      margin-bottom: 1.2rem;
      letter-spacing: 1.1px;
      text-shadow: 0 2px 8px rgba(6,53,71,0.10);
    }
    .about_section-modern p {
      color: #222;
      text-align: justify;
      margin-top: 1.2rem;
      line-height: 2.1rem;
      font-size: 1.13rem;
      font-weight: 500;
      margin-bottom: 1.5rem;
    }
    .about_section-modern .about-btn-modern {
      display: inline-block;
      background: linear-gradient(90deg, #7ee8fa 60%, #063547 100%);
      color: #063547;
      font-weight: 700;
      font-size: 1.08rem;
      border: none;
      border-radius: 8px;
      padding: 0.65rem 1.7rem;
      box-shadow: 0 2px 8px 0 rgba(6,53,71,0.10);
      transition: background 0.18s, color 0.18s, transform 0.18s;
      margin-top: 0.2rem;
      letter-spacing: 0.5px;
      cursor: pointer;
      text-decoration: none;
    }
    .about_section-modern .about-btn-modern:hover {
      background: linear-gradient(90deg, #063547 60%, #7ee8fa 100%);
      color: #fff;
      transform: scale(1.06);
    }
    @media (max-width: 900px) {
      .about_section-modern {
        padding: 1.2rem 0.5rem;
        border-radius: 12px;
      }
      .about_section-modern .detail-box {
        padding-left: 0.5rem;
      }
      .about_section-modern .heading_container h2 {
        font-size: 1.3rem;
      }
      .about_section-modern p {
        font-size: 0.98rem;
        line-height: 1.5rem;
      }
      .about_section-modern .about-btn-modern {
        font-size: 0.97rem;
        padding: 0.5rem 1.1rem;
      }
    }
  `;
  return (
    <div className="about_section-bg">
      <style>{aboutUsStyles}</style>
      <section className="about_section-modern">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="img-box">
                <img src={lib3} alt="Library" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="detail-box">
                <div className="heading_container">
                  <h2>About Our Library</h2>
                </div>
                <p>The Inigo library, with about 18,000 books and 228 journals, is open to and utilised not only by the staff and students, but also by some students, research scholars and other scholars from India and abroad.</p>
                {/*<Link to="/aboutus" className="about-btn-modern">Read More</Link>*/}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
